<template>
    <div class="privacy-container">
      <h2>Privacy Policy</h2>
      <p class="last-updated">Last Updated: June 2026</p>
      <p>
        Welcome to 6buoys! This Privacy Policy outlines how 6buoys ("we", "us", "our") collects, uses, and shares information when you use our social media app for water skiers. By using our app, you agree to the collection and use of your information in accordance with this Privacy Policy.
      </p>

      <h3>Information We Collect</h3>
      <p>We may collect the following types of information when you use our app:</p>
      <ul>
        <li><strong>Personal Information:</strong> When you create an account, we collect your name, email address, and a password. You may also choose to provide additional information, such as a profile picture, location, and water skiing interests.</li>
        <li><strong>User Content:</strong> We collect the content you post on our app, including photos, videos, comments, and other information you choose to share.</li>
      </ul>

      <h3>How We Use Your Information</h3>
      <p>We use the information we collect for various purposes, including:</p>
      <ul>
        <li><strong>Providing and improving our app:</strong> We use your information to provide and maintain our app, analyze usage patterns, and develop new features.</li>
        <li><strong>Communication:</strong> We use your information to communicate with you about updates, promotions, and other relevant information.</li>
        <li><strong>Security and fraud prevention:</strong> We use your information to maintain the security of our app and protect against unauthorized access, fraud, and other illegal activities.</li>
      </ul>

      <h3>Security</h3>
      <p>
        We take the security of your information seriously and implement appropriate technical and organizational measures to protect your information. However, no method of transmission or storage is completely secure, and we cannot guarantee the absolute security of your information.
      </p>

      <h3>Changes to This Privacy Policy</h3>
      <p>
        We may update this Privacy Policy from time to time. If we make any material changes, we will notify you by updating the "Last Updated" date at the top of this policy and, if required by law, through other means of communication.
      </p>

      <h3>Contact Us</h3>
      <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
      <ul>
        <li><a href="https://6buoys.com">6buoys.com</a></li>
        <li><a href="mailto:6buoysskiing@gmail.com">6buoysskiing@gmail.com</a></li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    metaInfo: {
      title: 'Privacy Policy',
      meta: [
        { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' }
      ]
    }
  };
  </script>
  
  <style scoped>
  .privacy-container {
    max-width: 600px;
    margin: 50px auto;
    padding: 20px;
    background-color: #192734;
    border-radius: 16px;
    color: #d9d9d9;
    text-align: left;
  }
  
  h2 {
    text-align: left;
    color: #1da1f2;
    margin-bottom: 20px;
  }
  
  h3 {
    color: #1da1f2;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  
  p {
    margin-bottom: 15px;
    line-height: 1.6;
    color: #e7e9ea;
  }

  .last-updated {
    font-size: 0.9em;
    font-style: italic;
    margin-top: -10px;
    color: #8899a6;
  }

  ul {
    margin: 0 0 15px;
    padding-left: 20px;
    color: #e7e9ea;
  }

  li {
    margin-bottom: 10px;
    line-height: 1.6;
  }

  li strong {
    color: #ffffff;
  }

  a {
    color: #1da1f2;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
  
  @media (max-width: 600px) {
    .privacy-container {
      padding: 15px;
      margin: 20px auto;
    }
  }
  </style>
